import React, {useState, useMemo} from 'react';
import {Fade, Stack, Box} from '@mui/material';
import AuthPage from './AuthPage';
import DemoUsersLoginPage from './DemoUsersLoginPage';
import {LOGIN_COLORS} from "./LoginShell";
import {getLogoutMessage, saveReturnUrl, consumeReturnUrl} from './loginReturnUrl';

export {saveReturnUrl, consumeReturnUrl} from './loginReturnUrl';

const LoginContainer = () => {
    // Get initial mode from localStorage or default to 'real'
    const [currentMode, setCurrentMode] = useState(() => {
        try {
            const savedMode = localStorage.getItem('loginMode');
            return savedMode === 'demo' ? 'demo' : 'real';
        } catch {
            return 'real';
        }
    });

    // Check for logout query param
    const logoutContext = useMemo(() => {
        const params = new URLSearchParams(window.location.search);
        if (!params.has('logout')) {
            return null;
        }
        return {
            message: getLogoutMessage(params.get('reason')),
        };
    }, []);

    const toggleMode = () => {
        setCurrentMode(prevMode => {
            const newMode = prevMode === 'real' ? 'demo' : 'real';
            // Save preference to localStorage
            try {
                localStorage.setItem('loginMode', newMode);
            } catch (error) {
                console.error('Failed to save login mode preference:', error);
            }
            return newMode;
        });
    };

    const logoutAlert = logoutContext ? (
        <Box
            sx={{
                borderRadius: 2,
                border: '1px solid #a7f3d0',
                bgcolor: '#ecfdf5',
                px: 2,
                py: 1.25,
                fontSize: 14,
                color: '#047857',
            }}
        >
            {logoutContext.message}
        </Box>
    ) : null;

    return (
        <Stack
            sx={{
                minHeight: '100vh',
                width: '100vw',
                justifyContent: 'center',
                alignItems: 'center',
                py: 4,
            }}
            bgcolor={LOGIN_COLORS.bg}
        >
            <Fade in={true} timeout={300}>
                <div style={{width: '100%', display: 'flex', justifyContent: 'center'}}>
                    {currentMode === 'real' ? 
                        <AuthPage alert={logoutAlert} onSwitchToDemo={toggleMode}/> : 
                        <DemoUsersLoginPage alert={logoutAlert} onBack={toggleMode}/>
                    }
                </div>
            </Fade>
        </Stack>
    );
};

export default LoginContainer;

